import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { getModalSwitch } from '@app/store/actions';
import { ModalActionsComponent } from '@app/components';
import OpenIDConnectConfigEdit from '../components/openIDConnectConfigEdit.component';
import { IUserDetail, IAgentClaims, IUserCustomAttribute } from '@app/models';
import { onPressEnterModal, genericErrorString } from '@app/helpers';
import { usersService } from '@app/services';

interface IProps {
    user: IUserDetail;
    selectedAgent: string;
    setIsNeedToUpdateAgentClaims: Function;
    agentClaims?: IAgentClaims;
}

const EditCustomClaimsDialog = (props: IProps) => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const [formValid, setFormValid] = useState(false);
    const [savingChanges, setSavingChanges] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const deserializedConfig = props.agentClaims?.Configuration ? JSON.parse(props.agentClaims.Configuration) : null;
    const getCustomClaimsMappingFromConfig = (config: any): IUserCustomAttribute => {
        if (!config) {
            return {};
        } else {
            return config;
        }
    };
    const [customClaimsMapping, setCustomClaimsMapping] = useState<IUserCustomAttribute>(getCustomClaimsMappingFromConfig(deserializedConfig));

    const handleError = (error: any) => {
        setSavingChanges(false);
        setErrorMessage(genericErrorString(error));
    };

    const handleSuccess = () => {
        setSavingChanges(false);
        props.setIsNeedToUpdateAgentClaims(true);
    };

    const closeConfirmModal = () => {
        dispatch(getModalSwitch(false));
    };

    const customConfigValid = (valid: boolean) => {
        setFormValid(valid);
    };
    const handleSaveClaim = (claim: IUserCustomAttribute) => {
        const requestData = {
            agentClientId: props.selectedAgent,
            configuration: JSON.stringify(claim),
        };

        setSavingChanges(true);
        usersService.addCustomClaimsForUser(requestData, handleSuccess, handleError);
    };

    return (
        <div onKeyPress={onPressEnterModal(handleSaveClaim, !formValid || savingChanges)}>
            <OpenIDConnectConfigEdit
                setCustomClaimsMapping={setCustomClaimsMapping}
                customClaimsMapping={customClaimsMapping}
                formValidCallback={customConfigValid}
                handleSaveClaim={handleSaveClaim}
            />
            {errorMessage !== '' && <span className='modal__error'>{errorMessage}</span>}
            <ModalActionsComponent
                secondaryBtn={translation('CLOSE_BUTTON')}
                onClickSecondary={closeConfirmModal}
                disabled={!formValid || savingChanges}
                id='addAgent'
            />
        </div>
    );
};

export default EditCustomClaimsDialog;
